<template>
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6722_6770)">
      <path
        d="M22.7003 8.13296C22.204 6.93881 21.1973 5.64947 20.4089 5.24189C20.9711 6.3305 21.3613 7.4996 21.5657 8.70763L21.5677 8.72679C20.2763 5.5086 18.0872 4.20895 16.2984 1.38272C16.2079 1.23979 16.1174 1.09656 16.0293 0.945375C15.9789 0.859026 15.9385 0.781224 15.9035 0.709611C15.8293 0.565957 15.7721 0.41414 15.7331 0.257237C15.7332 0.249997 15.7306 0.242991 15.7258 0.237555C15.721 0.23212 15.7144 0.228635 15.7072 0.227767C15.7002 0.225836 15.6927 0.225836 15.6857 0.227767C15.6842 0.227767 15.6819 0.230419 15.6801 0.231008C15.6783 0.231598 15.6745 0.23425 15.6718 0.235429L15.6763 0.227767C12.8073 1.90759 11.8333 5.01674 11.7449 6.57278C10.5988 6.65136 9.50293 7.07357 8.60037 7.78432C8.50624 7.70459 8.40787 7.63002 8.30567 7.56093C8.04544 6.64997 8.03435 5.68589 8.27355 4.76918C7.21993 5.27955 6.28374 6.0031 5.52423 6.89401H5.51893C5.06626 6.32022 5.09809 4.42821 5.12402 4.03301C4.99011 4.08683 4.86228 4.15469 4.74268 4.23547C4.34306 4.52067 3.96949 4.84069 3.62633 5.19179C3.23528 5.58826 2.87813 6.01679 2.55861 6.47288V6.47465V6.47258C1.82436 7.51337 1.30352 8.68928 1.02614 9.93243L1.01082 10.0079C0.989302 10.1084 0.911794 10.6117 0.898533 10.7211C0.898533 10.7296 0.896764 10.7376 0.89588 10.7461C0.795901 11.2658 0.733947 11.792 0.71051 12.3207V12.3797C0.715558 15.2379 1.79196 17.9904 3.72722 20.0937C5.66249 22.1971 8.31598 23.4985 11.1639 23.7411C14.0118 23.9836 16.8472 23.1497 19.1103 21.4039C21.3734 19.6581 22.8998 17.1274 23.3881 14.3112C23.4073 14.1638 23.4229 14.0179 23.44 13.8691C23.6753 11.9246 23.4206 9.95215 22.6991 8.13119L22.7003 8.13296ZM9.53577 17.0743C9.58911 17.1 9.63921 17.1277 9.69403 17.1521L9.70198 17.1571C9.64658 17.1306 9.59118 17.103 9.53577 17.0743ZM21.568 8.73003V8.71913L21.5701 8.73121L21.568 8.73003Z"
        fill="url(#paint0_linear_6722_6770)"
      />
      <path
        d="M22.7002 8.13301C22.204 6.93886 21.1972 5.64952 20.4089 5.24194C20.9711 6.33056 21.3613 7.49965 21.5656 8.70768V8.71859L21.5677 8.73067C22.4482 11.2501 22.3209 14.0124 21.2123 16.4402C19.9032 19.249 16.7357 22.128 11.7758 21.9865C6.41804 21.8348 1.69685 17.8577 0.815682 12.6503C0.655067 11.8289 0.815682 11.4125 0.896431 10.745C0.786285 11.2635 0.724818 11.7911 0.71283 12.3211V12.38C0.717877 15.2382 1.79428 17.9907 3.72954 20.0941C5.66481 22.1974 8.3183 23.4989 11.1662 23.7414C14.0141 23.984 16.8495 23.1501 19.1126 21.4043C21.3757 19.6585 22.9021 17.1277 23.3904 14.3115C23.4096 14.1642 23.4252 14.0183 23.4423 13.8695C23.6776 11.925 23.4229 9.9525 22.7014 8.13153L22.7002 8.13301Z"
        fill="url(#paint1_radial_6722_6770)"
      />
      <path
        d="M22.7002 8.13301C22.204 6.93886 21.1972 5.64952 20.4089 5.24194C20.9711 6.33056 21.3613 7.49965 21.5656 8.70768V8.71859L21.5677 8.73067C22.4482 11.2501 22.3209 14.0124 21.2123 16.4402C19.9032 19.249 16.7357 22.128 11.7758 21.9865C6.41804 21.8348 1.69685 17.8577 0.815682 12.6503C0.655067 11.8289 0.815682 11.4125 0.896431 10.745C0.786285 11.2635 0.724818 11.7911 0.71283 12.3211V12.38C0.717877 15.2382 1.79428 17.9907 3.72954 20.0941C5.66481 22.1974 8.3183 23.4989 11.1662 23.7414C14.0141 23.984 16.8495 23.1501 19.1126 21.4043C21.3757 19.6585 22.9021 17.1277 23.3904 14.3115C23.4096 14.1642 23.4252 14.0183 23.4423 13.8695C23.6776 11.925 23.4229 9.9525 22.7014 8.13153L22.7002 8.13301Z"
        fill="url(#paint2_radial_6722_6770)"
      />
      <path
        d="M17.148 9.47394C17.1727 9.49133 17.1957 9.50872 17.219 9.5261C16.9321 9.01735 16.5749 8.55156 16.1581 8.14246C12.6069 4.59126 15.2277 0.444746 15.6694 0.232558L15.6739 0.226074C12.8049 1.9059 11.8309 5.01504 11.7425 6.57109C11.8757 6.56195 12.0077 6.55076 12.1439 6.55076C13.1617 6.55272 14.1609 6.82418 15.0399 7.33752C15.9188 7.85085 16.6462 8.58777 17.148 9.47335V9.47394Z"
        fill="url(#paint3_radial_6722_6770)"
      />
      <path
        d="M12.1498 10.1841C12.1309 10.4682 11.1272 11.4481 10.7762 11.4481C7.5285 11.4481 7.00098 13.4129 7.00098 13.4129C7.14479 15.0673 8.29768 16.4306 9.69135 17.1497C9.755 17.1827 9.81954 17.2125 9.88408 17.2417C9.99587 17.2912 10.1077 17.337 10.2195 17.379C10.6978 17.5483 11.1987 17.6449 11.7057 17.6658C17.3994 17.9328 18.5016 10.8581 14.3931 8.80396C15.3622 8.67786 16.3437 8.91616 17.1471 9.47265C16.6453 8.58707 15.918 7.85015 15.039 7.33681C14.1601 6.82347 13.1609 6.55202 12.143 6.55005C12.0074 6.55005 11.8748 6.56125 11.7416 6.57038C10.5955 6.64896 9.49966 7.07117 8.5971 7.78192C8.77127 7.92927 8.96784 8.12614 9.3819 8.5343C10.157 9.29789 12.1448 10.0889 12.1492 10.1817L12.1498 10.1841Z"
        fill="url(#paint4_radial_6722_6770)"
      />
      <path
        d="M12.1498 10.1841C12.1309 10.4682 11.1272 11.4481 10.7762 11.4481C7.5285 11.4481 7.00098 13.4129 7.00098 13.4129C7.14479 15.0673 8.29768 16.4306 9.69135 17.1497C9.755 17.1827 9.81954 17.2125 9.88408 17.2417C9.99587 17.2912 10.1077 17.337 10.2195 17.379C10.6978 17.5483 11.1987 17.6449 11.7057 17.6658C17.3994 17.9328 18.5016 10.8581 14.3931 8.80396C15.3622 8.67786 16.3437 8.91616 17.1471 9.47265C16.6453 8.58707 15.918 7.85015 15.039 7.33681C14.1601 6.82347 13.1609 6.55202 12.143 6.55005C12.0074 6.55005 11.8748 6.56125 11.7416 6.57038C10.5955 6.64896 9.49966 7.07117 8.5971 7.78192C8.77127 7.92927 8.96784 8.12614 9.3819 8.5343C10.157 9.29789 12.1448 10.0889 12.1492 10.1817L12.1498 10.1841Z"
        fill="url(#paint5_radial_6722_6770)"
      />
      <path
        d="M8.06514 7.40503C8.15768 7.46398 8.234 7.51525 8.3009 7.56152C8.04068 6.65057 8.02958 5.68648 8.26878 4.76978C7.21517 5.28015 6.27898 6.00369 5.51947 6.8946C5.57517 6.89313 7.23201 6.86337 8.06514 7.40503Z"
        fill="url(#paint6_radial_6722_6770)"
      />
      <path
        d="M0.813637 12.6507C1.6951 17.8582 6.41599 21.8367 11.7737 21.987C16.7336 22.1273 19.9017 19.248 21.2102 16.4406C22.3188 14.0129 22.4462 11.2506 21.5656 8.73113V8.72023C21.5656 8.71168 21.5639 8.70667 21.5656 8.70932L21.5677 8.72848C21.9729 11.3741 20.6273 13.9359 18.5234 15.6718L18.5169 15.6865C14.4176 19.0255 10.495 17.7005 9.70226 17.16C9.64685 17.1335 9.59145 17.1059 9.53605 17.0772C7.14628 15.9349 6.15872 13.7588 6.3709 11.8904C5.80363 11.8988 5.2461 11.7424 4.76586 11.4404C4.28563 11.1383 3.9033 10.7034 3.66521 10.1885C4.29258 9.80414 5.00791 9.58688 5.74304 9.55737C6.47817 9.52786 7.20861 9.68709 7.86477 10.0199C9.21726 10.6338 10.7562 10.6943 12.1527 10.1885C12.1483 10.0956 10.1605 9.30434 9.38545 8.54105C8.97139 8.13288 8.77482 7.93631 8.60065 7.78866C8.50652 7.70893 8.40814 7.63436 8.30594 7.56528C8.23816 7.51901 8.16183 7.46891 8.07018 7.40879C7.23704 6.86712 5.58021 6.89688 5.52539 6.89836H5.52009C5.06742 6.32457 5.09925 4.43255 5.12518 4.03735C4.99127 4.09117 4.86344 4.15904 4.74383 4.23982C4.34422 4.52501 3.97065 4.84504 3.62749 5.19614C3.23504 5.59149 2.8764 6.01903 2.55535 6.47428V6.47604V6.47398C1.8211 7.51477 1.30025 8.69068 1.02288 9.93383C1.01728 9.95711 0.611469 11.7312 0.811574 12.6513L0.813637 12.6507Z"
        fill="url(#paint7_radial_6722_6770)"
      />
      <path
        d="M16.1578 8.14178C16.5748 8.55133 16.932 9.01763 17.2187 9.5269C17.2815 9.57435 17.3402 9.6215 17.39 9.66718C19.9796 12.0543 18.6227 15.4287 18.5216 15.6674C20.6253 13.9342 21.9697 11.3706 21.566 8.72412C20.274 5.50298 18.0825 4.20333 16.2966 1.3771C16.2061 1.23417 16.1157 1.09094 16.0275 0.93976C15.9772 0.853411 15.9368 0.775609 15.9017 0.703995C15.8275 0.560342 15.7704 0.408525 15.7314 0.251622C15.7314 0.244382 15.7288 0.237376 15.724 0.23194C15.7192 0.226505 15.7126 0.22302 15.7054 0.222151C15.6984 0.22022 15.691 0.22022 15.6839 0.222151C15.6824 0.222151 15.6801 0.224804 15.6783 0.225393C15.6766 0.225983 15.6727 0.228635 15.6701 0.229814C15.2283 0.43935 12.6081 4.58851 16.1593 8.13677L16.1578 8.14178Z"
        fill="url(#paint8_radial_6722_6770)"
      />
      <path
        d="M17.3897 9.66827C17.3399 9.62259 17.2812 9.57544 17.2184 9.52799C17.1952 9.5106 17.1722 9.49322 17.1474 9.47583C16.344 8.91934 15.3625 8.68104 14.3934 8.80714C18.5016 10.8612 17.3994 17.9342 11.706 17.6689C11.199 17.6481 10.6981 17.5515 10.2198 17.3822C10.108 17.3403 9.99618 17.2946 9.88439 17.2449C9.81985 17.2154 9.75531 17.1859 9.69165 17.1529L9.69961 17.1579C10.4935 17.6999 14.4149 19.024 18.5143 15.6844L18.5207 15.6697C18.623 15.4309 19.9798 12.0566 17.3891 9.66945L17.3897 9.66827Z"
        fill="url(#paint9_radial_6722_6770)"
      />
      <path
        d="M7.00126 13.4112C7.00126 13.4112 7.52849 11.4464 10.7764 11.4464C11.1274 11.4464 12.1321 10.4665 12.1501 10.1824C10.7536 10.6882 9.21458 10.6277 7.86209 10.0138C7.20594 9.68104 6.4755 9.52181 5.74037 9.55132C5.00524 9.58083 4.28991 9.79809 3.66254 10.1824C3.90063 10.6974 4.28295 11.1322 4.76319 11.4343C5.24342 11.7364 5.80095 11.8927 6.36823 11.8843C6.15663 13.7519 7.1439 15.9277 9.53337 17.0711C9.58671 17.0968 9.63681 17.1245 9.69163 17.149C8.29679 16.4284 7.14508 15.0657 7.00126 13.4121V13.4112Z"
        fill="url(#paint10_radial_6722_6770)"
      />
      <path
        d="M22.7003 8.13296C22.204 6.93881 21.1973 5.64947 20.409 5.24189C20.9711 6.3305 21.3613 7.4996 21.5657 8.70763L21.5677 8.72679C20.2763 5.5086 18.0873 4.20895 16.2984 1.38272C16.2079 1.23979 16.1175 1.09656 16.0293 0.945375C15.9789 0.859026 15.9386 0.781224 15.9035 0.709611C15.8293 0.565957 15.7722 0.41414 15.7332 0.257237C15.7332 0.249997 15.7306 0.242991 15.7258 0.237555C15.721 0.23212 15.7144 0.228635 15.7072 0.227767C15.7002 0.225836 15.6928 0.225836 15.6857 0.227767C15.6842 0.227767 15.6819 0.230419 15.6801 0.231008C15.6783 0.231598 15.6745 0.23425 15.6719 0.235429L15.6763 0.227767C12.8073 1.90759 11.8333 5.01674 11.7449 6.57278C11.8781 6.56365 12.0101 6.55245 12.1463 6.55245C13.1642 6.55442 14.1634 6.82587 15.0423 7.33921C15.9212 7.85255 16.6486 8.58947 17.1504 9.47505C16.347 8.91856 15.3655 8.68025 14.3964 8.80636C18.5046 10.8605 17.4024 17.9334 11.709 17.6682C11.202 17.6473 10.7011 17.5507 10.2227 17.3814C10.111 17.3396 9.99917 17.2938 9.88737 17.2441C9.82283 17.2146 9.75829 17.1851 9.69464 17.1521L9.70259 17.1571C9.64719 17.1306 9.59179 17.103 9.53638 17.0743C9.58972 17.1 9.63982 17.1277 9.69464 17.1521C8.2998 16.4313 7.14809 15.0686 7.00427 13.4153C7.00427 13.4153 7.5315 11.4505 10.7794 11.4505C11.1304 11.4505 12.1351 10.4706 12.1531 10.1865C12.1487 10.0936 10.1609 9.30235 9.38579 8.53906C8.97172 8.13089 8.77516 7.93432 8.60098 7.78668C8.50686 7.70695 8.40848 7.63237 8.30628 7.56329C8.04605 6.65233 8.03496 5.68824 8.27416 4.77154C7.22054 5.28191 6.28435 6.00545 5.52485 6.89637H5.51954C5.06687 6.32258 5.0987 4.43057 5.12464 4.03537C4.99072 4.08919 4.86289 4.15705 4.74329 4.23783C4.34367 4.52303 3.9701 4.84305 3.62694 5.19415C3.23589 5.59062 2.87874 6.01915 2.55922 6.47523V6.477V6.47494C1.82497 7.51573 1.30413 8.69163 1.02675 9.93479L1.01143 10.0102C0.989912 10.1107 0.893544 10.6212 0.879692 10.7308C0.791546 11.2577 0.735253 11.7894 0.711121 12.3231V12.382C0.716168 15.2402 1.79257 17.9927 3.72783 20.0961C5.6631 22.1995 8.3166 23.5009 11.1645 23.7434C14.0124 23.986 16.8478 23.1521 19.1109 21.4063C21.374 19.6605 22.9004 17.1297 23.3887 14.3135C23.4079 14.1662 23.4235 14.0203 23.4406 13.8715C23.6759 11.927 23.4212 9.95451 22.6997 8.13354L22.7003 8.13296ZM21.5672 8.71971L21.5692 8.7318L21.5672 8.71971Z"
        fill="url(#paint11_linear_6722_6770)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_6722_6770"
        x1="21.1884"
        y1="3.8762"
        x2="2.22618"
        y2="22.1715"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.048" stop-color="#FFF44F" />
        <stop offset="0.111" stop-color="#FFE847" />
        <stop offset="0.225" stop-color="#FFC830" />
        <stop offset="0.368" stop-color="#FF980E" />
        <stop offset="0.401" stop-color="#FF8B16" />
        <stop offset="0.462" stop-color="#FF672A" />
        <stop offset="0.534" stop-color="#FF3647" />
        <stop offset="0.705" stop-color="#E31587" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_6722_6770"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(20.4546 2.8784) scale(23.8122)"
      >
        <stop offset="0.129" stop-color="#FFBD4F" />
        <stop offset="0.186" stop-color="#FFAC31" />
        <stop offset="0.247" stop-color="#FF9D17" />
        <stop offset="0.283" stop-color="#FF980E" />
        <stop offset="0.403" stop-color="#FF563B" />
        <stop offset="0.467" stop-color="#FF3750" />
        <stop offset="0.71" stop-color="#F5156C" />
        <stop offset="0.782" stop-color="#EB0878" />
        <stop offset="0.86" stop-color="#E50080" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_6722_6770"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.6134 12.6037) scale(23.8122)"
      >
        <stop offset="0.3" stop-color="#960E18" />
        <stop offset="0.351" stop-color="#B11927" stop-opacity="0.74" />
        <stop offset="0.435" stop-color="#DB293D" stop-opacity="0.343" />
        <stop offset="0.497" stop-color="#F5334B" stop-opacity="0.094" />
        <stop offset="0.53" stop-color="#FF3750" stop-opacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_6722_6770"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.5605 -2.42628) scale(17.2491)"
      >
        <stop offset="0.132" stop-color="#FFF44F" />
        <stop offset="0.252" stop-color="#FFDC3E" />
        <stop offset="0.506" stop-color="#FF9D12" />
        <stop offset="0.526" stop-color="#FF980E" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_6722_6770"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.96107 18.7924) scale(11.3373)"
      >
        <stop offset="0.353" stop-color="#3A8EE6" />
        <stop offset="0.472" stop-color="#5C79F0" />
        <stop offset="0.669" stop-color="#9059FF" />
        <stop offset="1" stop-color="#C139E6" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_6722_6770"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12.7651 10.5595) rotate(-13.5916) scale(6.01203 7.03858)"
      >
        <stop offset="0.206" stop-color="#9059FF" stop-opacity="0" />
        <stop offset="0.278" stop-color="#8C4FF3" stop-opacity="0.064" />
        <stop offset="0.747" stop-color="#7716A8" stop-opacity="0.45" />
        <stop offset="0.975" stop-color="#6E008B" stop-opacity="0.6" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_6722_6770"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.3187 1.99424) scale(8.15746 8.15746)"
      >
        <stop stop-color="#FFE226" />
        <stop offset="0.121" stop-color="#FFDB27" />
        <stop offset="0.295" stop-color="#FFC82A" />
        <stop offset="0.502" stop-color="#FFA930" />
        <stop offset="0.732" stop-color="#FF7E37" />
        <stop offset="0.792" stop-color="#FF7139" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_6722_6770"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(17.8022 -3.31055) scale(34.8048 34.8048)"
      >
        <stop offset="0.113" stop-color="#FFF44F" />
        <stop offset="0.456" stop-color="#FF980E" />
        <stop offset="0.622" stop-color="#FF5634" />
        <stop offset="0.716" stop-color="#FF3647" />
        <stop offset="0.904" stop-color="#E31587" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_6722_6770"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(14.9094 -1.38075) rotate(83.976) scale(25.5054 16.739)"
      >
        <stop stop-color="#FFF44F" />
        <stop offset="0.06" stop-color="#FFE847" />
        <stop offset="0.168" stop-color="#FFC830" />
        <stop offset="0.304" stop-color="#FF980E" />
        <stop offset="0.356" stop-color="#FF8B16" />
        <stop offset="0.455" stop-color="#FF672A" />
        <stop offset="0.57" stop-color="#FF3647" />
        <stop offset="0.737" stop-color="#E31587" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_6722_6770"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(11.3187 4.94119) scale(21.7257)"
      >
        <stop offset="0.137" stop-color="#FFF44F" />
        <stop offset="0.48" stop-color="#FF980E" />
        <stop offset="0.592" stop-color="#FF5634" />
        <stop offset="0.655" stop-color="#FF3647" />
        <stop offset="0.904" stop-color="#E31587" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_6722_6770"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(16.9181 6.12018) scale(23.7798 23.7798)"
      >
        <stop offset="0.094" stop-color="#FFF44F" />
        <stop offset="0.231" stop-color="#FFE141" />
        <stop offset="0.509" stop-color="#FFAF1E" />
        <stop offset="0.626" stop-color="#FF980E" />
      </radialGradient>
      <linearGradient
        id="paint11_linear_6722_6770"
        x1="20.9586"
        y1="3.77895"
        x2="4.82639"
        y2="19.9141"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.167" stop-color="#FFF44F" stop-opacity="0.8" />
        <stop offset="0.266" stop-color="#FFF44F" stop-opacity="0.634" />
        <stop offset="0.489" stop-color="#FFF44F" stop-opacity="0.217" />
        <stop offset="0.6" stop-color="#FFF44F" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_6722_6770">
        <rect
          width="23.2347"
          height="24"
          fill="white"
          transform="translate(0.5 0.0100098)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>